import { useEffect, useState } from 'react';
import { TrendingUp, Inbox, CheckCircle2, Users, FileText } from 'lucide-react';
import { motion } from 'framer-motion';
import { api } from '../lib/api';
import { useI18n } from '../lib/i18n';

export default function Results() {
  const { t } = useI18n();
  const [data, setData] = useState(null);
  useEffect(() => { (async () => {
    try { const { data } = await api.get('/transparency'); setData(data.aggregates); } catch {}
  })(); }, []);

  const cards = data ? [
    { icon: Users, label: t.transparency.users, value: data.users_count, color: '#0EA5E9' },
    { icon: Inbox, label: t.transparency.requests, value: data.requests_count, color: '#8B5CF6' },
    { icon: CheckCircle2, label: t.transparency.resolved, value: data.resolved_count, color: '#10B981' },
    { icon: TrendingUp, label: t.transparency.donations, value: `€${data.donations_total.toLocaleString()}`, color: '#C5A059' },
    { icon: FileText, label: 'Articoli verificati', value: 8, color: '#0F172A' },
  ] : [];

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
      <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-medium mb-4">Tikkun</p>
      <h1 className="font-display text-5xl md:text-6xl font-medium tracking-tight leading-tight">{t.results.title}</h1>
      <p className="mt-4 text-lg text-muted-foreground">{t.results.subtitle}</p>

      <div className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {cards.map((c, i) => (
          <motion.div key={c.label}
            initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.05 }}
            className="p-6 rounded-3xl border border-border bg-card">
            <div className="inline-flex h-10 w-10 items-center justify-center rounded-full mb-4" style={{ backgroundColor: `${c.color}18`, color: c.color }}>
              <c.icon size={18} strokeWidth={1.75} />
            </div>
            <div className="text-xs uppercase tracking-widest text-muted-foreground">{c.label}</div>
            <div className="font-display text-3xl md:text-4xl font-medium tracking-tight mt-1">{c.value}</div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
